// @ts-nocheck
import { FieldModel } from '@cibo/core'
import { Stack, Typography } from '@mui/material'
import { GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'
import { pluck, sum } from 'ramda'

interface ProgramColumnFunctionProps {
  programId: string
  t: TFunction
}

export const fieldProgramEarningsColumn = ({ programId, t }: ProgramColumnFunctionProps) => ({
  field: 'earnings',
  headerName: t('earnings'),
  flex: 1,
  minWidth: 80,
  sortable: false,
  valueGetter: (params: GridValueGetterParams<string, FieldModel>) => {
    const credits = params.row.programCreditsEarned(programId)
    const dollarsData = params.row.programDollarsEarned(programId)

    return {
      credits: sum(pluck('amount', credits).filter(v => !!v) as number[]),
      dollars: sum(pluck('amount', dollarsData).filter(v => !!v) as number[]),
    }
  },
  renderCell: ({
    value,
  }: GridRenderCellParams<
    { dollars: number; credits: number; creditYears: number[]; dollarYears: number[] },
    FieldModel
  >) => {
    if (value === undefined || !(value.dollars > 0) || !(value.credits > 0)) {
      return '--'
    }
    return (
      <Stack>
        {value.dollars > 0 && (
          <Typography variant="body2">{t('dollarsAmount', { dollars: value.dollars })}</Typography>
        )}
        {value.credits > 0 && (
          <Typography variant="body2">{t('creditsAmount', { credits: value.credits })}</Typography>
        )}
      </Stack>
    )
  },
})
